const getExampleJobLocationByNation = (hirerNation: string) => {
  switch (hirerNation) {
    case 'AU':
      return 'Canberra';

    case 'NZ':
      return 'Wellington CBD Wellington';

    case 'MY':
      return 'Kuala Lumpur';

    case 'SG':
      return 'Raffles Place Central Region';

    case 'HK':
      return 'Central and Western District';

    case 'PH':
      return 'Manila City Metro Manila';

    case 'TH':
      return 'กรุงเทพฯ';

    case 'ID':
      return 'Central Jakarta Jakarta';

    default:
      return 'Unknown Location';
  }
};

export { getExampleJobLocationByNation };
